import styled from 'styled-components';

export const MethodPayment = styled.div`
  font-weight: bold;
  display: flex;
  color: inherit;
  align-items: center;
  font-size: 13px;
  padding: 2.5px 5px;

  svg {
    font-size: 30px;
    margin-right: 16px;
    color: inherit !important;
  }
`;

export const SvgTicket = styled.svg`
  width: 30px;
  height: 30px;
  padding: 2px;
  fill: inherit !important;
`;

export const MethodsContainer = styled.div``;
